/**
 * TODO - replace this with Fluent UI utility
 * https://github.com/microsoft/fluentui/pull/28428
 */ export function mergeCallbacks(callback1, callback2) {
    return (...args)=>{
        callback1 == null ? void 0 : callback1(...args);
        callback2 == null ? void 0 : callback2(...args);
    };
}

//# sourceMappingURL=mergeCallbacks.js.map